var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { env } from '../environment';
import style from '../css/buttons_css';
let Button = class Button extends LitElement {
    constructor() {
        super(...arguments);
        this.text = 'Default Text';
        this.type = 'button';
        this.family = '';
        this.version = '';
        this.href = '';
        this.target = '';
        this.icon = '';
        this.icon_pos = 'after';
        this.aim = 'gs1';
        this.disabled = undefined;
    }
    static get styles() {
        if (env.debug) {
            return css ``;
        }
        return [style];
    }
    updateVersion() {
        let result = '';
        const versionArray = this.version.split(' ');
        versionArray.forEach((item) => {
            result = result.concat(' btn-' + item);
        });
        return result;
    }
    render() {
        let versions = '';
        versions = this.updateVersion();
        const familyClass = this.aim && this.aim !== 'gs1' ? `${this.aim}-${this.family}` : this.family;
        const icon_family = this.icon.split(' ')[0];
        const icon_type = this.icon.split(' ')[1];
        let icon_class = '';
        if (icon_type != '') {
            if (this.icon_pos == 'after') {
                icon_class = 'btn-icon-after';
            }
            else {
                icon_class = 'btn-icon-before';
            }
        }
        if (this.href != '') {
            return html `
        ${env.debug
                ? html `<link rel="stylesheet" href="${env.baseUrl}/css/buttons.css" />`
                : html ``}

        <a
          role="button"
          part="button"
          class="btn ${icon_class} btn-${familyClass}${versions}"
          href="${this.href}"
          target="${this.target}"
          ?disabled=${this.disabled}
        >
          ${this.icon_pos != 'before' ? this.text : html ``}
          ${this.version.includes('has-arrow')
                ? html ` <gs1-fa-icon
                family="far"
                type="fa-arrow-right"
              ></gs1-fa-icon>`
                : icon_type
                    ? html `<gs1-fa-icon
                  family="${icon_family}"
                  type="${icon_type}"
                ></gs1-fa-icon>`
                    : html ``}
          ${this.icon_pos == 'before' ? this.text : html ``}
        </a>
      `;
        }
        else {
            return html `
        ${env.debug
                ? html `<link rel="stylesheet" href="${env.baseUrl}/css/buttons.css" />`
                : html ``}

        <button
          type="${this.type}"
          part="button"
          class="btn ${icon_class} btn-${familyClass}${versions}"
          ?disabled=${this.disabled}
        >
          ${this.icon_pos != 'before' ? this.text : html ``}
          ${this.version.includes('has-arrow')
                ? html ` <gs1-fa-icon
                family="far"
                type="fa-arrow-right"
              ></gs1-fa-icon>`
                : icon_type
                    ? html `<gs1-fa-icon
                  family="${icon_family}"
                  type="${icon_type}"
                ></gs1-fa-icon>`
                    : html ``}
          ${this.icon_pos == 'before' ? this.text : html ``}
        </button>
      `;
        }
    }
};
__decorate([
    property()
], Button.prototype, "text", void 0);
__decorate([
    property()
], Button.prototype, "type", void 0);
__decorate([
    property()
], Button.prototype, "family", void 0);
__decorate([
    property()
], Button.prototype, "version", void 0);
__decorate([
    property()
], Button.prototype, "href", void 0);
__decorate([
    property()
], Button.prototype, "target", void 0);
__decorate([
    property()
], Button.prototype, "icon", void 0);
__decorate([
    property()
], Button.prototype, "icon_pos", void 0);
__decorate([
    property()
], Button.prototype, "aim", void 0);
__decorate([
    property({ reflect: true })
], Button.prototype, "disabled", void 0);
Button = __decorate([
    customElement('gs1-button')
], Button);
export { Button };
//# sourceMappingURL=buttons.js.map